import { Routes } from '@angular/router';
import { isAuthenticated } from '@sona/angular-auth-api';
import { termsGuard } from '@sona/angular-auth-domain';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { hasSeenOnboardingPage, markOnboardingSeen } from '@sona/angular-onboarding/api';
import { paymentsRoutes } from '@sona/angular-payments';
import { redirectTo } from '@sona/angular-util-router';

import { LegalLayout } from '../layouts/legal/legal.layout';
import { AppRootLayout } from '../layouts/root/root.layout';

export const APP_ROUTES: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('@sona/angular-auth-shell').then((m) => m.AUTH_ROUTES)
    },
    {
        path: '',
        component: AppRootLayout,
        children: [
            {
                path: 'scan',
                canActivate: [ isAuthenticated([ '/auth/login' ]), termsGuard({ currentTermsNotAccepted: redirectTo('/auth/accept-terms') }), hasSeenOnboardingPage ],
                loadChildren: () => import('@sona/angular-scan-shell').then((m) => m.SHELL_ROUTES)
            },
            {
                path: 'reports',
                canActivate: [ isAuthenticated([ '/auth/login' ]), termsGuard({ currentTermsNotAccepted: redirectTo('/auth/accept-terms') }) ],
                loadChildren: () => import('@sona/angular-reports').then((m) => m.ROUTES)
            },
            {
                path: 'targets',
                redirectTo: 'domains'
            },
            {
                path: 'domains',
                canActivate: [ isAuthenticated([ '/auth/login' ]), termsGuard({ currentTermsNotAccepted: redirectTo('/auth/accept-terms') }) ],
                loadChildren: () => import('@sona/angular-target-shell').then((m) => m.targetRoutes)
            },
            {
                path: 'organization',
                canActivate: [ isAuthenticated([ '/auth/login' ]), termsGuard({ currentTermsNotAccepted: redirectTo('/auth/accept-terms') }) ],
                loadChildren: () => import('@sona/angular-organization-feature-page').then((m) => m.organizationSettingsRoutes)
            },
            {
                path: 'onboarding',
                canActivate: [ isAuthenticated([ '/auth/login' ]), markOnboardingSeen ],
                loadComponent: () => import('@sona/angular-onboarding/page').then(m => m.OnboardingPage)
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'scan'
            },
            {
                path: '',
                data: {},
                component: LegalLayout,
                children: [
                    {
                        path: 'imprint',
                        data: {
                            breadcrumb: {
                                label: 'PAGE.IMPRINT.TITLE',
                                link: '/imprint'
                            }
                        },
                        loadComponent: () => import('../pages/imprint/imprint.page').then(m => m.ImprintPage)
                    },
                    {
                        path: 'privacy',
                        data: {
                            breadcrumb: {
                                label: 'PAGE.PRIVACY.TITLE',
                                link: '/privacy'
                            }
                        },
                        loadComponent: () => import('../pages/privacy/privacy.page').then(m => m.PrivacyPage)
                    },
                    {
                        path: 'terms',
                        data: {
                            breadcrumb: {
                                label: 'PAGE.TERMS.TITLE',
                                link: '/terms'
                            }
                        },
                        loadComponent: () => import('../pages/terms/terms.page').then(m => m.TermsPage)
                    }
                ]
            },
            {
                path: 'billing',
                children: paymentsRoutes
            },
            {
                path: 'forbidden',
                loadComponent: () => import('../pages/forbidden.page').then((m) => m.ForbiddenPage)
            },
            {
                path: '**',
                loadComponent: () => import('../pages/not-found.page').then((m) => m.NotFoundPage)
            }
        ]
    }
];
